export default __webpack_public_path__ + "static/media/a006-b.dc2c7733.png";